import { Dispatch, createContext } from 'react';
import { IAppContextReducerAction } from '@interfaces/IAppContextReducerAction';
import { IUser } from '@interfaces/IUser';

interface AppContextType {
  state: IUser;
  dispatch: Dispatch<IAppContextReducerAction>;
}

// @ts-expect-error context
const AppContext = createContext<AppContextType>();

export default AppContext;
